export function getAvatar(id?: string | null) {
  if (id) {
    return import.meta.env.VITE_API_DOMAIN + id;
  }
  return undefined;
}
